import React from 'react'

function EditIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="#56565A"
        d="M21.256 6.138 17.83 2.713a2.5 2.5 0 0 0-3.325-.088l-11.25 11.25a2.5 2.5 0 0 0-.712 1.513l-.538 5.213a1.25 1.25 0 0 0 1.25 1.362h.113l5.212-.475a2.5 2.5 0 0 0 1.513-.712l11.25-11.25a2.4 2.4 0 0 0-.087-3.388Zm-12.9 12.85-3.75.35.337-3.75 7.062-6.975 3.375 3.375-7.025 7Zm8.65-8.675-3.35-3.35 2.437-2.5 3.412 3.413-2.5 2.437Z"
      />
    </svg>
  )
}
export default EditIcon
